import { space } from 'styled-system';
import styled from 'styled-components';
//////////////////////////////////////////////////

const FormGroup = styled.div`
  display: flex;
  min-height: 30px;
  align-items: ${({ align }) => align || 'center'};
  flex-direction: ${({ direction }) => direction || 'column'};

  ${({ additionClass }) => additionClass}
`;

export const CalendarMuiFormGroup = styled(FormGroup)`
  ${space}

  z-index: unset;
  justify-content: ${({ jc }) => jc || 'baseline'};
  position: ${({ active }) => active && 'relative'};
`;
